<template>
  <SelectBoxes items-name="select_box" :items="items" :default-index="2" />
</template>

<script>
import SelectBoxes from '../../components/molecules/select_boxes/SelectBoxes'
export default {
  components: { SelectBoxes },
  data() {
    return {
      items: [
        {
          name: '60分60分60分60分60分60分60分60分60分60分60分60分',
          value: 1,
          is_out_of_stock: false
        },
        {
          name: '30分',
          value: 2,
          is_out_of_stock: false
        },
        {
          name: '10分',
          value: 3,
          is_out_of_stock: true
        },
        {
          name: '1分',
          value: 4,
          is_out_of_stock: false
        }
      ]
    }
  }
}
</script>
